var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewTraining(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 5,
    fill: "#21E190"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6225 12.7622L25.8022 10.9419L27.1706 9.57402C27.2916 9.45316 27.3596 9.28939 27.3596 9.1181C27.3596 8.94681 27.2916 8.78304 27.1706 8.66213L25.3385 6.83003C25.0967 6.58818 24.6684 6.58818 24.4265 6.83003L23.0587 8.19843L21.2381 6.37777C20.7344 5.87408 19.9177 5.87408 19.414 6.37777C18.9102 6.88145 18.9102 7.69814 19.414 8.20187L25.7983 14.5863C26.3021 15.09 27.1188 15.09 27.6225 14.5863C28.1262 14.0826 28.1262 13.266 27.6225 12.7622Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5863 25.8111L8.20192 19.4266C7.69814 18.9229 6.88154 18.9229 6.37777 19.4266C5.87408 19.9304 5.87408 20.7471 6.37777 21.2507L8.19839 23.0714L6.83265 24.4365C6.71171 24.5575 6.64369 24.7212 6.64369 24.8925C6.64369 25.0638 6.71171 25.2276 6.83265 25.3485L8.66476 27.18C8.79069 27.306 8.9557 27.369 9.12072 27.369C9.28573 27.369 9.45075 27.306 9.57668 27.18L10.9419 25.8148L12.7622 27.6352C13.2659 28.1389 14.0826 28.1389 14.5863 27.6352C15.0901 27.1314 15.0901 26.3147 14.5863 25.8111Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5892 13.6738L13.6738 17.6025L16.41 20.3387L20.3254 16.4099L17.5892 13.6738Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7982 16.4106L17.5896 8.20198C17.0859 7.6983 16.2692 7.6983 15.7655 8.20198C15.2618 8.70576 15.2618 9.52236 15.7655 10.0261L23.9741 18.2347C24.4778 18.7384 25.2945 18.7384 25.7982 18.2347C26.302 17.731 26.302 16.9143 25.7982 16.4106Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2347 23.9877L10.0261 15.7791C9.52243 15.2754 8.70574 15.2754 8.20205 15.7791C7.69828 16.2829 7.69828 17.0996 8.20205 17.6033L16.4106 25.8119C16.9143 26.3155 17.731 26.3155 18.2347 25.8119C18.7385 25.3082 18.7385 24.4915 18.2347 23.9877Z",
    fill: "#EBEBEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 5,
    height: 1,
    fill: "#EBEBEB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.00049,
    y: 11.0283,
    width: 4.99582,
    height: 1,
    transform: "rotate(-89.9583 7.00049 11.0283)",
    fill: "#EBEBEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTraining);
export default __webpack_public_path__ + "static/media/newTraining.09281f719c4dc82d2fe86ba7f739272f.svg";
export { ForwardRef as ReactComponent };